// import { logger } from '@/helpers';
import { defineComponent ,computed, onMounted ,ref} from 'vue'

import { useStore } from "vuex";

import WelcomeBox from "@/components/WelcomeBox/WelcomeBox.vue";
import PopupCookie from "@/components/PopupCookie/PopupCookie.vue";
import ConsentCampaign from "@/components/ConsentCampaign/ConsentCampaign.vue";
import ButtonOpenCard from "@/components/ButtonOpenCard/ButtonOpenCard.vue";


import { useGtag } from "vue-gtag-next";

import {  ApiService } from '@/api/api';

export default defineComponent({
  // type inference enabled

  components:{
  
    WelcomeBox,
    PopupCookie,
    ConsentCampaign,
    ButtonOpenCard
  },
  setup() {
    const store = useStore();

    // console.log(store.state.logs)
    const ShowCookies = computed(() => store.getters['GetPopupCookies'])
    const AllowCookie = localStorage.getItem("allow_cookie") 
    const ShowConsent = ref(true)


    const { pageview } = useGtag();
    const ShowBTStart = computed(() => store.getters['GetBTStart'])


    onMounted( async () => {
      // eslint-disable-next-line
      (window as any).fbq('track', 'ViewContent') 
     
      pageview({ page_path: "/Home" });

      if(AllowCookie =='true'){
        // console.log('is Allow')
        ShowConsent.value=false
        store.dispatch('SetBTStart',true)

      }

      const RequestResp = await ApiService.CheckStatus()
      const {data}  = RequestResp 
      if(data.result == 'complete'){
        // console.log('complete')
      }else{
        if(data.detail == 'campaign_not_start'){
          store.dispatch('SetBTStart',false)
          ShowConsent.value = false
        }
      }
      

    
    })

    return {ShowCookies,ShowConsent,ShowBTStart}
  

  },
})
